import {
  ShieldCheck,
  Fingerprint,
  Network,
  Cpu,
  Volume2,
  Code2,
  Cctv,
  Camera,
  BellRing,
  Zap,
  Home,
  Car,
  MonitorPlay,
  Wrench,
  Dumbbell,
  ScanLine,
  ScanFace,
  Wifi,
  Server,
  Lock,
  Box,
  Boxes,
  Puzzle,
  Sparkles,
  Workflow,
  Layers,
  Waypoints,
  Radio,
  MonitorDot,
} from "lucide-react";

const MAP = {
  ShieldCheck,
  Fingerprint,
  Network,
  Cpu,
  Volume2,
  Code2,
  Cctv,
  Camera,
  BellRing,
  Zap,
  Home,
  Car,
  MonitorPlay,
  Wrench,
  Dumbbell,
  ScanLine,
  ScanFace,
  Wifi,
  Server,
  Lock,
  Box,
  Boxes,
  Puzzle,
  Sparkles,
  Workflow,
  Layers,
  Waypoints,
  Radio,
  MonitorDot,
};

export const ICON_NAMES = Object.keys(MAP);

export const getIcon = (name) => MAP[name] || Box;
